import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { CustomEase } from "gsap/CustomEase";


gsap.registerPlugin(ScrollTrigger);
gsap.registerPlugin(CustomEase);


const animate404 = () => {
  const animationErrorPage = gsap.timeline({
    paused: false,
  });


  animationErrorPage.fromTo(
    ".main-404 .text-container",
    {
      opacity: 0,
      y: -100,
      autoAlpha: 0,
    },
    {
      opacity: 1,
      autoAlpha: 1,
      y: 0,
      duration: 0.9,
      ease: "power2.inOut",
    }
  )
  animationErrorPage.fromTo(
    ".image-404_2",
    {
      scale: 2,
      rotate: 3,
      xPercent: 0,
      yPercent: -50,
      autoAlpha: 0,
    },
    {
      scale: 1,
      rotate: 12,
      autoAlpha: 1,
      xPercent: 0,
      yPercent: 0,
      duration: 0.9,
      ease: "power2.inOut",
    },
    '>-0.4'
  )
  animationErrorPage.fromTo(
    ".image-404_1",
    {
      scale: 2,
      rotate: 0,
      xPercent: -50,
      yPercent: 60,
      autoAlpha: 0,
    },
    {
      scale: 1,
      rotate: -14,
      autoAlpha: 1,
      xPercent: 0,
      yPercent: 0,
      duration: 0.9,
      ease: "power2.inOut",
    },
    '>-0.4'
  )
  animationErrorPage.fromTo(
    ".image-404_3",
    {
      scale: 2,
      rotate: 3,
      xPercent: 50,
      yPercent: 60,
      autoAlpha: 0,
    },
    {
      scale: 1,
      rotate: 12,
      autoAlpha: 1,
      xPercent: 0,
      yPercent: 0,
      duration: 0.9,
      ease: "power2.inOut",
    },
    '>-0.4'
  )

  ;


};

  




export default animate404;
